/** @format */
import {
    containerFluid,
    dangerColor,
    defaultFont,
    drawerMiniWidth,
    drawerWidth,
    transition,
    whiteColor,
} from '../../../../jss/material-dashboard-pro-react';
import OPL_STYLE from '../../OplStyle';
import oplTableStyle from '../Table/OplTableStyle';
import oplButtonStyle from '../Buttons/OplButtonStyle';
import oplPaginatorStyle from '../Paginator/OplPaginatorStyle';
import cardStyle from '../Components/Card/CardStyle';
import loginPageStyle from '../LoginPage/LoginPageStyle';
import COLORS from '../../colors';
import inputStyle from '../Components/InputStyle';
import selectStyle from '../Components/SelectStyle';
import adminNavbarStyle from '../AdminNavbar/AdminNavbarStyle';

const OplAppStyle = (theme: any): any => ({
    ...oplTableStyle,
    ...oplButtonStyle,
    ...oplPaginatorStyle,
    ...cardStyle,
    ...loginPageStyle,
    ...inputStyle,
    ...selectStyle,
    ...adminNavbarStyle,
    wrapper: {
        position: 'relative',
        top: '0',
        height: '100vh',
        '&:after': {
            display: 'table',
            clear: 'both',
            content: '" "',
        },
    },
    loginWrapper: {
        height: 'auto',
        minHeight: '100vh',
        position: 'relative',
        top: '0',
    },
    mainPanel: {
        transitionProperty: 'top, bottom, width',
        transitionDuration: '.2s, .2s, .35s',
        transitionTimingFunction: 'linear, linear, ease',
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
        },
        overflow: 'auto',
        position: 'relative',
        float: 'right',
        ...transition,
        maxHeight: '100%',
        width: '100%',
        overflowScrolling: 'touch',
        backgroundColor: OPL_STYLE.BACKGROUND.TERTIARY,
    },
    content: {
        marginTop: '70px',
        padding: '30px 15px',
        minHeight: 'calc(100vh - 123px)',
    },
    container: { ...containerFluid },
    map: {
        marginTop: '70px',
    },
    mainPanelSidebarMini: {
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerMiniWidth}px)`,
        },
    },
    mainPanelWithPerfectScrollbar: {
        overflow: 'auto !important',
    },
    fullPage: {
        padding: '120px 0',
        position: 'relative',
        minHeight: '100vh',
        display: 'flex!important',
        margin: '0',
        border: '0',
        color: COLORS.MAIN.LIGHT,
        alignItems: 'center',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            minHeight: 'fit-content!important',
        },
        '& footer': {
            position: 'absolute',
            bottom: '0',
            width: '100%',
            border: 'none !important',
        },
        '&:before': {
            backgroundColor: COLORS.MAIN.DARK,
        },
        '&:before,&:after': {
            display: 'block',
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '0',
            left: '0',
            zIndex: '2',
        },
    },
    search: {
        margin: '0',
        paddingTop: '7px',
        paddingBottom: '7px',
        [theme.breakpoints.down('sm')]: {
            margin: '10px 15px',
            float: 'none !important',
            paddingTop: '1px',
            paddingBottom: '1px',
            padding: '10px 15px',
            width: 'auto',
        },
    },
    searchInput: {
        paddingTop: '2px',
    },
    searchRTL: {
        [theme.breakpoints.down('sm')]: {
            marginRight: '18px !important',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: '12px',
        },
    },
    linkText: {
        zIndex: '4',
        ...defaultFont,
        fontSize: '14px',
        margin: '0!important',
        textTransform: 'none',
    },
    buttonLink: {
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            margin: '5px 15px 0',
            width: 'auto',
            height: 'auto',
            '& svg': {
                width: '30px',
                height: '24px',
                marginRight: '19px',
                marginLeft: '3px',
            },
            '& .fab,& .fas,& .far,& .fal,& .material-icons': {
                width: '30px',
                fontSize: '24px',
                lineHeight: '30px',
                marginRight: '19px',
                marginLeft: '3px',
            },
        },
    },
    searchButton: {
        [theme.breakpoints.down('sm')]: {
            top: '-50px !important',
            marginRight: '38px',
            float: 'right',
        },
    },
    top: {
        zIndex: '4',
    },
    searchIcon: {
        width: '17px',
        zIndex: '4',
    },
    links: {
        width: '20px',
        height: '20px',
        zIndex: '4',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            width: '30px',
            height: '30px',
            color: 'inherit',
            marginRight: '16px',
            marginLeft: '-5px',
        },
    },
    notifications: {
        zIndex: '4',
        [theme.breakpoints.up('md')]: {
            position: 'absolute',
            top: '5px',
            border: '1px solid ' + whiteColor,
            right: '5px',
            fontSize: '9px',
            background: dangerColor[0],
            color: whiteColor,
            minWidth: '16px',
            height: '16px',
            borderRadius: '10px',
            textAlign: 'center',
            lineHeight: '14px',
            verticalAlign: 'middle',
            display: 'block',
        },
        [theme.breakpoints.down('sm')]: {
            ...defaultFont,
            fontSize: '14px',
            marginRight: '8px',
        },
    },
    wrapperRTL: {
        [theme.breakpoints.up('md')]: {
            paddingLeft: '16px',
        },
    },
    buttonLinkRTL: {
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '-webkit-fill-available',
            margin: '10px 15px 0',
            padding: '10px 15px',
            display: 'block',
            position: 'relative',
        },
    },
    labelRTL: {
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'row-reverse',
            justifyContent: 'initial',
            display: 'flex',
        },
    },
    linksRTL: {
        [theme.breakpoints.down('sm')]: {
            marginRight: '-5px !important',
            marginLeft: '16px !important',
        },
    },
    managerClasses: {
        [theme.breakpoints.up('md')]: {
            display: 'inline-block',
        },
    },
    headerLinksSvg: {
        width: '20px !important',
        height: '20px !important',
    },
    pooperResponsive: {
        zIndex: '1200',
        [theme.breakpoints.down('sm')]: {
            zIndex: '1640',
            position: 'static',
            float: 'none',
            width: 'auto',
            marginTop: '0',
            border: '0',
            boxShadow: 'none',
            color: 'black',
        },
    },
    pooperNav: {
        [theme.breakpoints.down('sm')]: {
            position: 'static !important',
            left: 'unset !important',
            top: 'unset !important',
            transform: 'none !important',
            willChange: 'none !important',
            '& > div': {
                boxShadow: 'none !important',
                marginLeft: '1.5rem',
                marginRight: '1.5rem',
                transition: 'none !important',
                marginTop: '0px !important',
                marginBottom: '5px !important',
                padding: '0px !important',
            },
        },
    },
});

export default OplAppStyle;
